import { findAcknowledgment } from 'helpers/acknowledgments';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useAcknowledgments from 'services/acknowledgments/useAcknowledgments';
import { AcknowledgmentResource } from 'types/Acknowledgment';

export default function useAcknowledgment(
  acknowledgmentType: AcknowledgmentResource,
  resourceId: string,
) {
  const { data: acknowledgments } = useAcknowledgments();
  const { currentTinyAccountId, currentKitId } = useCurrentKitAndTinyAccount();

  return findAcknowledgment(
    acknowledgments,
    acknowledgmentType,
    resourceId,
    currentTinyAccountId ?? '',
    currentKitId ?? '',
  );
}
